export const SPARTAN_SECTION_QUERY_KEY = 'section';

const SPARTAN_PENDING_SECTION_KEY = 'spartan-pending-section';

/** Legacy deep-link ids → current product section ids. */
const SPARTAN_SECTION_ALIASES: Record<string, string> = {
  feature: 'highlights',
  lineup: 'model-lineup',
};

const resolveSpartanSectionAlias = (section: string): string =>
  SPARTAN_SECTION_ALIASES[section] ?? section;

/** Stash a section to restore after a clean (no hash/query) page navigation. */
export const setSpartanPendingSection = (section: string): void => {
  try {
    sessionStorage.setItem(SPARTAN_PENDING_SECTION_KEY, section);
  } catch {
    // ignore quota / private-mode failures
  }
};

/** Peek a pending section without clearing (safe under React Strict Mode). */
export const peekSpartanPendingSection = (): string | null => {
  try {
    return sessionStorage.getItem(SPARTAN_PENDING_SECTION_KEY);
  } catch {
    return null;
  }
};

/** Clear a pending section after it has been applied. */
export const clearSpartanPendingSection = (): void => {
  try {
    sessionStorage.removeItem(SPARTAN_PENDING_SECTION_KEY);
  } catch {
    // ignore
  }
};

/** Resolve section from pending handoff, then legacy `?section=` query. */
export const getSpartanSectionFromLocation = (
  searchParams: URLSearchParams | null | undefined
): string | null => {
  const pending = peekSpartanPendingSection();
  if (pending) return resolveSpartanSectionAlias(pending);

  const section = searchParams?.get(SPARTAN_SECTION_QUERY_KEY);
  return section ? resolveSpartanSectionAlias(section) : null;
};
